import React, { PropTypes } from 'react';

const Logo = (props) => {
    return (
        <div className="logo">
            <img src="/assets/images/quickresponse/logo.jpg" width="250" />
        </div>
    );
};

// Logo.propTypes = {
//     results : PropTypes.object.isRequired,
// };

export default Logo;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/Logo.jsx